import { Percent } from '@pancakeswap/sdk'
import { SeverityErrorText, Text } from '@pancakeswap/uikit'
import { warningSeverity } from 'utils/exchange'
import { ONE_BIPS } from 'config/constants/exchange'
import { severityVariants } from '@pancakeswap/uikit/components/SeverityErrorText/SeverityErrorText.css'

/**
 * Formatted version of price impact text with warning colors
 */
export default function FormattedPriceImpact({ priceImpact }: { priceImpact?: Percent }) {
  return (
    <Text fontSize="14px">
      {priceImpact ? (priceImpact.lessThan(ONE_BIPS) ? '<0.01%' : `${priceImpact.toFixed(2)}%`) : '-'}
    </Text>
  )
}
